"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayComponent = OverlayComponent;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ui_1 = require("~/store/game/ui");
const OverlayComponent_styles_1 = require("./OverlayComponent.styles");
function OverlayComponent({ title, children, fullscreen = false, }) {
    const styles = (0, OverlayComponent_styles_1.useStyles)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const dispatchCloseOverlay = () => dispatch((0, ui_1.closeOverlay)());
    return (React.createElement("div", { className: styles.overlay },
        fullscreen ? null : (React.createElement("div", { className: styles.header },
            typeof title === "string" ? (React.createElement("h2", null, title)) : (React.createElement("div", { className: styles.titleChild }, title)),
            React.createElement("button", { className: styles.closeButton, onClick: dispatchCloseOverlay }, "X"))),
        React.createElement("div", { className: styles.overlayContent }, children)));
}
